import React, { Component } from "react";
import DemandDetail from "./DemandDetail";
import $ from "jquery";

function openModal(modal) {
  $("#modal"+ modal).modal("show");
  $("#modal"+ modal).appendTo("container");
  $("#modal"+ modal).detach().appendTo("#container-fluid");
}

export default class RenderDemandDetail extends Component {
  render() {
    return (
      <div>
        <a
          onClick={()=> openModal(this.props.data.talepNo)}
          href={"#" + this.props.data.talepNo}
        >
          <span className="t-detayButton">Detay</span>
        </a>
        <DemandDetail demand={this.props.data}></DemandDetail>
      </div>
    );
  }
}
